import { Ng2StateDeclaration } from '@uirouter/angular';
import { TripDashboardComponent } from './containers/trip-dashboard/trip-dashboard.component';
import { TripOverviewComponent } from "./containers/trip-overview/trip-overview.component";

export const tripDashboardState: Ng2StateDeclaration = {
    name: 'trip-dashboard',
    url: '/dashboard/trip/project/:projectId?query&from&to,&trainIds&goodtrips&main',
    component: TripDashboardComponent,
    params: {
        projectId: {squash: true, value: null},
        query: {squash: true, value: null},
        from: {squash: true, value: null},
        to: {squash: true, value: null},
        trainIds: {squash: true, value: null},
        main: {squash: true, value: null},
        goodtrips: {squash: true, value: null}
    }
};

export const tripOverviewState: Ng2StateDeclaration = {
    name: 'trips-overview',
    url: '/overview/trip/project/:projectId?query&from&to,&trainIds&goodTrips',
    component: TripOverviewComponent,
    params: {
        projectId: {squash: true, value: null},
        query: {squash: true, value: null},
        from: {squash: true, value: null},
        to: {squash: true, value: null},
        trainIds: {squash: true, value: null},
        goodTrips: {squash: true, value: null}
    }
};

export const REPORTING_STATES = [
    tripDashboardState,
    tripOverviewState
];
